import React from 'react'
import { APP_NAME } from 'configs/AppConfig';
import { Button } from "antd";

export default function Footer({isMobile}) {
	const Mailto = ({ email, subject, body, ...props }) => {
		return (
			<Button type="primary">
			<a className="text-gray"  href={`mailto:${email}?subject=${subject || ""}&body=${body || ""}`}>
					<span style={{ color: 'white' }}>{props.children}</span>
				</a>
			</Button>
		);
	}

	return (
		<footer className="footer">
			<span>Copyright  &copy;  {`${new Date().getFullYear()}`} <span className="font-weight-semibold">{`${APP_NAME}`}</span> All rights reserved.</span>
			<span>AI-generated. For educational use only.</span><a className="text-gray" target={'_blank'} href="https://www.speakho.co/privacy-policy#disclaimer" rel="noreferrer">Learn More</a>
			{isMobile ?
				<div style={{paddingTop:'20px', paddingBottom:'20px'}}>
					<Mailto email="contactus@speakho.co" subject="Feedback" body="Please share your detailed feedback">
						Give Feedback
					</Mailto>

				</div> :
				<div>
					<Mailto email="contactus@speakho.co" subject="Feedback" body="Please share your detailed feedback">
						Give Feedback
					</Mailto>

				</div>
		}
			
		</footer>
	)
}

